import { directive as vClickOutside } from "../node_modules/vue-clickaway";
import session from "@/kuaa/kuaa-sessions";

/**
 * You can register global directives here and use them as a plugin in your main Vue instance
 */

const GlobalDirectives = {
  install(Vue) {
    Vue.directive("click-outside", vClickOutside);

    Vue.directive('focus', {
      inserted: function (el) {
        el.focus();
      }
    });

    Vue.directive('mask-phone-number', {
      update(el, binding, vnode) {
        let event = new Event("input", { bubbles: true });
        el.value = el.value.replace(/[^0-9]/g, "").replace(/(^02|^0505|^1[0-9]{3}|^0[0-9]{2})([0-9]+)?([0-9]{4})$/,"$1-$2-$3").replace("--", "-");
        el.dispatchEvent(event);
      }
    });

    Vue.directive('mask-date-time', {
      update(el, binding, vnode) {
        let event = new Event("input", { bubbles: true });
        el.value = el.value.replace(/[^0-9]/g, "").replace(/(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})$/,"$1-$2-$3 $4:$5");
        el.dispatchEvent(event);
      }
    });

    Vue.directive('exel-btn', {
      bind(el, binding, vnode) {
        let userGroup = session.get('group');
        el.style.display = 'none';
        if(binding.value && Array.isArray(binding.value)){
          binding.value.forEach((arr)=>{
            if(arr == userGroup){
              el.style.display = 'block';
            }
          });
        }
      }
    });

    Vue.directive('auth-btn', {
      bind(el, binding, vnode) {
        let userGroup = session.get('group');
        el.style.display = 'none';
        if(binding.value && Array.isArray(binding.value)){
          binding.value.forEach((auth)=>{
            if(auth == userGroup){
              el.style.display = 'block';
            }
          });
        }
      }
    });
  }
};

export default GlobalDirectives;
